module.exports = __webpack_public_path__ + "static/img/video.559c4451.svg";